<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row">

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <TraderMultiselect :multiple="true" v-model="tradersFilter">
                      </TraderMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="overflow-auto">
                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.trader') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.limit_amount') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.limit_currency') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.count_mode') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.plan_type') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.timer_interval') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.stop_status') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.period_started_at') }}</th>
                    <th class="text-end">
                      <button v-if="canEdit" type="button" v-on:click="showEditModal()" class="btn btn-outline-primary btn-sm text-capitalize">{{ helper.trans('button.create') }}</button>
                      <b-modal
                               :modelValue="createModal"
                               body-class="pt-0"
                               hide-header
                               @update:modelValue="createModal = $event"
                      >
                        <template #default>
                          <TraderPayoutPlanForm ref="createForm"></TraderPayoutPlanForm>
                        </template>
                        <template #footer>
                          <button type="button" v-on:click="createModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                          <LoaderWrapper ref="loaderCreateFrom" :zoom="0.5">
                            <button type="button" @click="save()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
                          </LoaderWrapper>
                        </template>
                      </b-modal>
                      <b-modal
                               :title="deleteModalTitle"
                               :modelValue="deleteModal"
                               body-class="pt-0"
                               @update:modelValue="deleteModal = $event"
                      >
                        <template #default>
                          <p>{{ helper.trans('messages.confirm_delete_payout_plan') }}</p>
                        </template>
                        <template #footer>
                          <button type="button" v-on:click="deleteModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                          <LoaderWrapper ref="loaderDelete" :zoom="0.5">
                            <button type="button" @click="deletePlan()" class="btn btn-outline-danger btn-sm text-capitalize-first">{{ helper.trans('button.delete') }}</button>
                          </LoaderWrapper>
                        </template>
                      </b-modal>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in response.items" :key="item.id" class="">
                    <td>{{ item.id }}</td>
                    <td>
                      <UserNameLabel v-if="item._trader" :user="item._trader"></UserNameLabel>
                      <span v-else>ID: {{ item.traderId }}</span>
                    </td>
                    <td>
                      <template v-if="item.planType === 'limit' && item.limitAmount">
                        {{ numberFormatter.formatNumber(parseFloat(item.limitAmount), 2) }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td>
                      <template v-if="item.planType === 'limit' && item.limitCurrency">
                        {{ item.limitCurrency }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td>
                      <template v-if="item.planType === 'limit' && item.countMode">
                        {{ helper.trans(`payout_plans.count_mode.${item.countMode}`) }}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td>{{ helper.trans(`payout_plans.plan_type.${item.planType}`) }}</td>
                    <td>
                      <template v-if="item.planType === 'timer' && item.expiredAtManual">
                        {{ dateHelper.format(item.expiredAtManual)}}
                      </template>
                      <template v-else>
                        {{ helper.trans('labels.not_set') }}
                      </template>
                    </td>
                    <td>
                      <span v-if="item.isPayOutTrafficBlocked" class="text-danger">{{ helper.trans('payout_plans.status.blocked') }}</span>
                      <span v-else class="text-success">{{ helper.trans('payout_plans.status.active') }}</span>
                    </td>
                    <td>
                      <template v-if="item.periodStartedAt">
                        {{ dateHelper.format(item.periodStartedAt)}}
                      </template>
                      <template v-else>
                        -
                      </template>
                    </td>
                    <td class="text-end">
                      <button v-if="canEdit" type="button" @click="showEditModal(item)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-pencil"></i> {{helper.trans('button.edit')}}</button>
                      <button v-if="canEdit" type="button" @click="showDeleteModal(item)" class="btn btn-sm btn-outline-danger text-nowrap text-capitalize ms-2"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="response.totalCount > response.items.length"
                  v-model="page"
                  :total-rows="response.totalCount"
                  :per-page="response.limit"
                  :limit="20"
                  @update:modelValue="loadList()"
                  prev-text="Back"
                  next-text="Next"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import TraderPayoutPlanDTO from "@/models/TraderPayoutPlanDTO";
import TraderPayoutPlanForm from "@/components/Form/TraderPayoutPlanForm.vue";
import TraderPayoutPlanFormDTO from "@/models/form/TraderPayoutPlanFormDTO";
import {Dictionary} from "@/types";
import TraderDTO from "@/models/TraderDTO";
import PaginationDTO from "@/models/PaginationDTO";
import UserNameLabel from "@/components/UserNameLabel.vue";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import {UserPermission} from "@/models/enum/UserPermission";

const notification = useNotification()
const defaultForm = {
  id: null,
  trader: null,
  traderId: null,
  planType: null,
  limitAmount: null,
  limitCurrency: null,
  countMode: null,
  expiredAtManual: null,
} as TraderPayoutPlanFormDTO

export default defineComponent({
  components: {
    TraderMultiselect,
    UserNameLabel,
    TraderPayoutPlanForm,
    LoaderWrapper,
    CopyButton,
    BPagination,
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderCreateFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderDelete = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const createForm = ref<InstanceType<typeof TraderPayoutPlanForm> | null>(null)

    const canEdit = computed(() => {
      return store.getters.isAdmin || (store.getters.isOperator && store.getters.hasPermission(UserPermission.EDIT_MANUAL_PRIORITIES))
    })

    const state = reactive({
      tradersFilter: [] as TraderDTO[],
      requestDTO: {
        traderIds: [] as number[]
      } as any,
      createModalTitle: '',
      createModal: false,
      deleteModalTitle: '',
      deleteModal: false,
      selectedPlanId: 0,
      page: 1,
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<TraderPayoutPlanDTO>
    });

    const loadList = async () => {
      loader.value?.show()
      state.requestDTO.traderIds = state.tradersFilter.map((value) => value.id)

      state.response.offset = state.response.limit * (state.page - 1)
      state.response = await api.call.traderPayoutPlans.list(state.response, state.requestDTO);

      let traderIds = [];
      for (const item of state.response.items) {
        traderIds.push(item.traderId)
      }

      if (traderIds.length > 0) {
        let traders = {} as Dictionary<TraderDTO>;
        for (const trader of (await api.traders({offset:0, limit: traderIds.length} as PaginationDTO, {ids: traderIds})).items) {
          traders[trader.id] = trader
        }

        for (const item of state.response.items) {
          item._trader = traders[item.traderId] ?? null;
        }
      }

      loader.value?.hide()
    }

    const showEditModal = async (dto: TraderPayoutPlanDTO|null = null) => {
      if (dto) {
        state.createModalTitle = helper.trans("labels.edit_payout_plan", {id: dto.id})
        createForm.value?.setForm({
          ...defaultForm,
          id: dto.id,
          trader: dto._trader,
          traderId: dto.traderId,
          planType: dto.planType,
          limitAmount: dto.limitAmount,
          limitCurrency: dto.limitCurrency,
          countMode: dto.countMode,
          expiredAtManual: dto.expiredAtManual,
        } as TraderPayoutPlanFormDTO)
      } else {
        state.createModalTitle = helper.trans("labels.create_payout_plan")
        createForm.value?.setForm({...defaultForm} as TraderPayoutPlanFormDTO)
      }

      state.createModal = true;
    }

    const save = () => {
      loaderCreateFrom.value?.show()

      createForm.value!.save()
        .then(() => {
          state.createModal = false;
          notification.notify({
            type: 'success',
            title: helper.trans('success'),
            text: helper.trans('success.payout_plan_saved')
          })
          loadList();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          loaderCreateFrom.value?.hide();
        })
    }

    const showDeleteModal = async (dto: TraderPayoutPlanDTO) => {
      state.deleteModalTitle = helper.trans("labels.delete_payout_plan")
      state.selectedPlanId = dto.id
      state.deleteModal = true;
    }

    const deletePlan = () => {
      loaderDelete.value?.show()

      api.call.traderPayoutPlans.delete(state.selectedPlanId)
        .then(() => {
          state.deleteModal = false;
          notification.notify({
            type: 'success',
            title: helper.trans('success'),
            text: helper.trans('success.payout_plan_deleted')
          })
          loadList();
        })
        .catch((error) => {
          notification.notify({
            type: 'error',
            title: helper.trans('error'),
            text: helper.trans('error.unable_to_delete_payout_plan')
          })
        })
        .finally(() => {
          loaderDelete.value?.hide();
        })
    }

    const applyFilters = async () => {
      state.page = 1
      loadList()
    }

    const clearFilters = async () => {
      state.tradersFilter = [];
      state.requestDTO = {
        traderIds: []
      }
      state.page = 1
      loadList()
    }

    onMounted(async () => {
      loadList()
    });

    return {
      ...toRefs(state),
      store,
      loader,
      loaderCreateFrom,
      loaderDelete,
      dateHelper,
      numberFormatter,
      helper,
      createForm,
      save,
      showEditModal,
      showDeleteModal,
      deletePlan,
      loadList,
      clearFilters,
      applyFilters,
      canEdit,
      UserPermission
    }
  }
})
</script>
